import styled from 'styled-components';

const Wrapper = styled.nav`
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f1f5f9;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  position: sticky;
  top: 0;
  z-index: 50;

  .nav-center {
    display: flex;
    width: 90%;
    align-items: center;
    justify-content: space-between;
  }

  .toggle-btn {
    background: #f1f5f9;
    border: none;
    width: 38px;
    height: 38px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    color: #6366f1;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    &:hover { background: #e0e7ff; color: #4f46e5; }
  }

  .logo {
    display: flex;
    align-items: center;
    width: 34px;
  }

  .logo-text {
    display: none;
    font-size: 1rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.02em;
    text-transform: capitalize;
    margin: 0;
  }

  .btn-container {
    position: relative;
  }

  .btn {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 0.45rem 0.875rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
    box-shadow: none;
    svg { color: #6366f1; font-size: 1rem; }
    &:hover { background: #f1f5f9; border-color: #c7d2fe; }
  }

  .dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 130px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.1);
    padding: 0.4rem;
    visibility: hidden;
    opacity: 0;
    transform: translateY(-4px);
    transition: opacity 0.15s, transform 0.15s, visibility 0.15s;
  }

  .show-dropdown {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }

  .dropdown-btn {
    display: block;
    width: 100%;
    padding: 0.5rem 0.75rem;
    background: transparent;
    border: none;
    border-radius: 7px;
    font-size: 0.85rem;
    font-weight: 600;
    color: #dc2626;
    cursor: pointer;
    text-align: left;
    text-transform: capitalize;
    transition: background 0.15s;
    &:hover { background: #fee2e2; }
  }

  @media (min-width: 992px) {
    .logo { display: none; }
    .logo-text { display: block; }
  }
`;

export default Wrapper;
